import { ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import PlatsaUncoupledSlidingDoorComponent from '../api/components/PlatsaUncoupledSlidingDoorComponent';
export const getSlidingDoorOnFrame = (frame, coreApi) => {
    const slidingDoors = coreApi.entities.getChildrenWithProductType(frame, ProductType.PLATSA_SLIDING_DOOR_ASM);
    return slidingDoors.length > 0 ? slidingDoors[0] : null;
};
export const alignedFramesHasSlidingDoor = (frame, coreApi) => {
    const alignedFrames = coreApi.entities.getAlignedFrames(frame, 'align-frame-left', 'align-frame-right', true, true);
    const leftFrameHasSlidingDoors = alignedFrames.left &&
        coreApi.entities.findChildWithProductType(alignedFrames.left, ProductType.PLATSA_SLIDING_DOOR_ASM);
    const rightFrameHasSlidingDoors = alignedFrames.right &&
        coreApi.entities.findChildWithProductType(alignedFrames.right, ProductType.PLATSA_SLIDING_DOOR_ASM);
    return leftFrameHasSlidingDoors || rightFrameHasSlidingDoors;
};
export const getFrameGroupsWithSlidingDoors = (coreApi) => {
    const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
    const groups = [];
    framesInScene.forEach(frame => {
        if (getSlidingDoorOnFrame(frame, coreApi) && !groups.some(group => group.includes(frame))) {
            groups.push([frame]);
            const frameNeighbors = coreApi.entities.getAlignedFrames(frame, 'align-frame-left', 'align-frame-right', true, true);
            let leftNeigbor = frameNeighbors.left;
            while (leftNeigbor && getSlidingDoorOnFrame(leftNeigbor, coreApi)) {
                groups[groups.length - 1].push(leftNeigbor);
                leftNeigbor = coreApi.entities.getAlignedFrames(leftNeigbor, 'align-frame-left', 'align-frame-right', true, true).left;
            }
            let rightNeighbour = frameNeighbors.right;
            while (rightNeighbour && getSlidingDoorOnFrame(rightNeighbour, coreApi)) {
                groups[groups.length - 1].push(rightNeighbour);
                rightNeighbour = coreApi.entities.getAlignedFrames(rightNeighbour, 'align-frame-left', 'align-frame-right', true, true).right;
            }
        }
    });
    return groups;
};
export const isSlidingDoorLeftFrontLayout = (frontLayout) => frontLayout.globalItemNo === 'ASM-42465576';
export const isSlidingDoorRightFrontLayout = (frontLayout) => frontLayout.globalItemNo === 'ASM-42465577';
export const isSlidingDoorUncoupled = (slidingDoor, coreApi) => {
    const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(slidingDoor, ComponentIds.FRAME_COMPONENT_ID);
    return frame && !alignedFramesHasSlidingDoor(frame, coreApi);
};
export const getUncoupledSlidingDoors = (coreApi) => {
    const slidingDoors = coreApi.entities.getByProductType(ProductType.PLATSA_SLIDING_DOOR_ASM);
    const uncoupledSlidingDoors = [];
    slidingDoors.forEach(door => {
        if (isSlidingDoorUncoupled(door, coreApi)) {
            uncoupledSlidingDoors.push(door);
        }
    });
    return uncoupledSlidingDoors;
};
export const deleteUncoupledSlidingDoors = (coreApi) => {
    const uncoupledSlidingDoors = getUncoupledSlidingDoors(coreApi);
    uncoupledSlidingDoors.forEach(door => {
        door.removeComponent(PlatsaUncoupledSlidingDoorComponent.id);
        coreApi.entities.delete(door);
    });
};
export const addSlidingDoorFrontLayoutToFrame = (frontLayout, frame, coreApi) => {
    const alignedFrame = isSlidingDoorLeftFrontLayout(frontLayout)
        ? coreApi.entities.getAlignedFrames(frame, 'align-frame-left', 'align-frame-right', true, true)
            .left
        : coreApi.entities.getAlignedFrames(frame, 'align-frame-left', 'align-frame-right', true, true)
            .right;
    if (!alignedFrame) {
        return;
    }
    const frameIsSelected = frame.hasComponent(ComponentIds.SELECTED_COMPONENT_ID);
    [frame, alignedFrame].forEach(frame => {
        const existingRegularFronts = HierarchyUtils.children(frame).filter(child => coreApi.entities.isOneOfProductTypes(child, [
            ProductType.PLATSA_HINGE_DOOR_ASM,
            ProductType.PLATSA_DRAWER_ASM
        ]));
        coreApi.entities.deleteMultiple(existingRegularFronts);
        const placementResult = coreApi.products.addToTarget(frontLayout.coreProductId, frame);
        if (placementResult.valid && placementResult.placedEntity) {
            coreApi.placementService.dissolveEntity(placementResult.placedEntity);
        }
    });
    if (frameIsSelected) {
        coreApi.entities.select(frame);
    }
};
export const isFrameSuitableForPullOutInterior = (frame, coreApi) => {
    const slidingDoor = coreApi.entities.getChildrenWithProductType(frame, ProductType.PLATSA_SLIDING_DOOR_ASM)[0];
    if (!slidingDoor) {
        return true;
    }
    const frameSize = coreApi.entities.getEntityComSize(slidingDoor);
    const alignedFrames = coreApi.entities.getAlignedFrames(frame, 'align-frame-left', 'align-frame-right', true, true);
    const slidingDoorLeft = alignedFrames.left &&
        coreApi.entities.getChildrenWithProductType(alignedFrames.left, ProductType.PLATSA_SLIDING_DOOR_ASM)[0];
    const slidingDoorRight = alignedFrames.right &&
        coreApi.entities.getChildrenWithProductType(alignedFrames.right, ProductType.PLATSA_SLIDING_DOOR_ASM)[0];
    if (frameSize && frameSize.width < 800) {
        return true;
    }
    else if ((slidingDoorLeft && coreApi.entities.getEntityComSize(slidingDoorLeft)?.width === 800) ||
        (slidingDoorRight && coreApi.entities.getEntityComSize(slidingDoorRight)?.width === 800)) {
        return true;
    }
    else {
        return false;
    }
};
//# sourceMappingURL=slidingDoorUtils.js.map